var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ninja-keys',{ref:"ninjakeys",attrs:{"no-auto-load-md-icons":true,"hideBreadcrumbs":"","placeholder":_vm.placeholder,"disableHotkeys":_vm.disableHotkeys},on:{"selected":_vm.onSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }